<template>
  <ul id="list-tasks">
    <li>
        <!-- pc view -->
        <div class="oblea"  v-if='!mobileView'>
            <div class="fh lc" style="width: 100%; height:25%;">
                <div class="fh lc" style="width: 75%; height:100%; font-weight: 500; font-size: 15px; color: #5c666f; margin-left: 10px;">
                   Presup: {{item.Numero}}
                </div>
                <div class="fh rc" style="width: 25%; height:100%; margin-right: 10px;" @click="btnVer">
                   <img id="iconoVer" style="width: 15px; height:15px"  src="/dist/icon-ver.png" />
                   <div style="font-size: 11px; margin-left: 5px; color: #5c666f;">VER</div>
                </div>
            </div>
            <div class="fh lt" style="width: 100%; height:15%; margin-left: 10px; margin-right: 10px; font-weight: 400;
                               font-size: 9px; color: #5c666f;">
                <div class="fh lc" style="width: 77%; height:100%" > {{item.Fecha | filterFecha}} </div>
                <div class="fh lc" style="width: 20%; height:100%;"> 
                    <div :id="`circulo${item.Estado}`" > </div>
                </div>
            </div>
            <div class="fh lc" style="width: 100%; height:30%;" >
                <div class="fh lc" style="width: 75%; height:100%; font-weight: 500; font-size: 16px; color: #4969B2; margin-left: 10px;" >
                    ${{item.MontoTotal | formatMoney}} 
                </div>
                <div class="fh rc" style="width: 25%; height:100%; font-size: 11px; color: #5c666f; margin-right: 10px" >
                    TOTAL  
                </div>
            </div>
            <div class="fh lc" style="width: 100%; height:30%;" >
                <div class="fh lc" style="width: 75%; height:100%; font-weight: 500; font-size: 20px; color: #4969B2; margin-left: 10px">
                    {{item.CantidadItems}}  
                </div>
                <div class="fh rc" style="width: 25%; height:100%; font-size: 11px; color: #5c666f; margin-right: 10px" >
                    ITEMS  
                </div>
            </div>
        </div> 

        <!-- mobile view -->
        <div class="oblea" style="width: 140px; height: 90px;" v-if='mobileView' @click="btnVer">
          <div class="fh lc" style="width: 100%; height:25%;">
            <div class="fh lb" style="width: 75%; height:100%; font-size: 12px; font-weight: 500; margin-left: 5px;">Pedido: {{item.Numero}}</div>
            <div class="fh rb" style="width: 25%; height:100%; margin-right: 5px;">
              <img style="width: 15px; height:15px"  src="/dist/icon-ver.png" />
            </div>
          </div>
          <div class="fh lt" style="width: 100%; height:25%; font-weight: 400; font-size: 8px; color: #5c666f; margin-left: 5px; margin-right: 5px">
            <div class="fh lc" style="width: 77%; height:100%" > {{item.Fecha | filterFecha}} </div>
            <div class="fh lc" style="width: 23%; height:100%;"> 
              <div :id="`circulo${item.Estado}`" > </div>
            </div>
          </div>
          <div class="fh lc" style="width: 100%; height:25%;" >
            <div class="fh lc" style="width: 75%; height:100%; font-weight: 500; font-size: 12px; color: #4969B2; margin-left: 5px;" >
              ${{item.MontoTotal | formatMoney}} 
            </div>
            <div class="fh rc" style="width: 25%; height:100%; font-size: 8px; color: #5c666f; margin-left: 5px; margin-right: 5px" >
              Monto  
            </div>
          </div>
          <div class="fh lc" style="width: 100%; height:25%;" >
            <div class="fh lc" style="width: 75%; height:100%; font-weight: 500; font-size: 12px; color: #4969B2; margin-left: 5px;" >
              {{item.CantidadItems}}  
            </div>
            <div class="fh rc" style="width: 25%; height:100%; font-size: 8px; color: #5c666f; margin-right: 5px" >
              Items  
            </div>
          </div>
        </div> 
    </li>
  </ul>
</template>

 
<script>
  export default {
    name: 'item-presupuesto-home',

    props: ['item'],

    data() {
       return {
        mobileView:false
       }
    },

    filters: {
      filterFecha (fecha) {
        return fecha   
      }
    },


    methods: {
      onResize() {
        if (window.innerWidth > 600) 
        {
           this.mobileView=false;
        }
        else 
        {
           this.mobileView=true;
        }
      },
      btnVer() {
        this.$store.commit('pedido/savePedidoId',this.item); 
        this.$router.push({ name: 'presupuestoCms' });
      }
    },

    mounted() {
      this.onResize()
    },

    created() {
     window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   float: left;
   display: block;
   padding-right: 20px;
   text-decoration: none;
  }
  

.oblea{
    display: flex;
    flex-direction: column;
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px solid #dddddd;
    background: #ffffff;
    box-shadow: 2px 2px 4px #dddddd;  
    -webkit-box-shadow: 2px 2px 4px #dddddd;  
    -moz-box-shadow:    2px 2px 4px #dddddd;  
}


 #circulo0 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #FFC107;  
    margin: 10px;
   }
  
  
  
  /*confirmado 1*/
  #circulo1 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #4CD964;  
    margin: 10px;
  }
  
  
  
  /*eliminado 2*/
  #circulo2 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: red;  
    margin: 10px;
  }
    
  
  /*procesanso 3*/
  #circulo3 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: yellow;  
    margin: 10px;
  }
    
  
  /*guardado 99*/
  #circulo99 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #D0D2D3;  
    margin: 10px;
  }



#iconoVer:hover {
    cursor: pointer;
}

.oblea:hover{
    background: #f9f9f9;
}      

        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemPresupuestoHome.vue